define('views/menu',["exports", "backbone", "bootstrap/dropdown", "loader", "bootstrap/modal"], function (_exports, _backbone, _dropdown, _loader, _modal) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _modal = _interopRequireDefault(_modal);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .menu-dropdown-currency .dropdown-menu button'({
        currentTarget: btn
      }) {
        this.hide();
        GA.currency(btn.value);
      },
      'click .menu-dropdown-language .dropdown-menu button'({
        currentTarget: btn
      }) {
        var lang = btn.value;
        var link = document.head.querySelector(`link[rel=alternate][hreflang=${lang}]`);
        if (link) {
          location.href = link.getAttribute('href');
        } else {
          var _location$search;
          location.href = new URL(`${location.pathname}${(_location$search = location.search) !== null && _location$search !== void 0 ? _location$search : ''}`, btn.getAttribute('href')).href;
        }
      },
      'hide.bs.dropdown'() {
        (0, _loader.enableLoader)();
      },
      'show.bs.dropdown'() {
        (0, _loader.disableLoader)();
      }
    },
    initialize() {
      this.menu = new _modal.default(this.el, _objectSpread(_objectSpread({}, _modal.default.DEFAULTS), {}, {
        show: false
      }));
      this.menuUser = this.el.querySelector('.js-user');
      this.menuGuest = this.el.querySelector('.js-guest');
      var currencyToggle = this.el.querySelector('.menu-dropdown-currency [data-toggle=dropdown]');
      var currencyMenu = this.el.querySelector('.menu-dropdown-currency .dropdown-menu');
      GA.currency((m, currency) => {
        currencyToggle.textContent = currencyMenu.querySelector(`button[value=${currency}]`).getAttribute('aria-label');
        currencyToggle.classList.remove('b-menu-header__btn--currency-eur', 'b-menu-header__btn--currency-usd', 'b-menu-header__btn--currency-gbp', 'b-menu-header__btn--currency-rub');
        currencyToggle.classList.add(`b-menu-header__btn--currency-${currency.toLowerCase()}`);
      });
    },
    show() {
      this.el.hidden = false;
      this.menu.show();
    },
    hide() {
      this.el.hidden = true;
      this.menu.hide();
    },
    setUser(user) {
      if (user.role === 'user') {
        var _user$avatar;
        this.menuUser.querySelector('.b-menu-header__btn-text').textContent = user.name;
        var avatar = this.menuUser.querySelector('.b-menu-header__btn-avatar');
        avatar.src = (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : '/img/avatars/default.png';
        avatar.alt = user.name;
      }
      this.menuGuest.hidden = user.role === 'user';
      this.menuUser.hidden = user.role === 'guest';
    }
  });
});//# sourceMappingURL=menu.js.map
;
